"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const Button_1 = require("./Button");
const Text_1 = require("./Text");
const colors_1 = require("../styles/colors");
const CircleCloseIcon_1 = require("./Icons/CircleCloseIcon");
const getFieldStyle = () => ({
    minHeight: 71,
    width: '100%',
    marginTop: 24,
    display: 'block',
});
const renderTextControlButtons = (deleteText, media, startEditingText, text, editButton) => {
    switch (media) {
        case 'Desktop':
            return (React.createElement("div", { style: { display: 'flex' } },
                text && (React.createElement(Button_1.default, { onClick: deleteText, text: "Remove", type: "regular", style: {
                        innerStyle: {
                            fontSize: 17,
                            marginRight: 8,
                        },
                    }, mouseDownColors: {
                        active: colors_1.turquoise,
                        inactive: colors_1.aquamarine,
                    } })),
                editButton));
        case 'Tablet':
        case 'Mobile':
        default:
            const Fragment = React.Fragment;
            return (React.createElement(Fragment, null,
                React.createElement(CircleCloseIcon_1.default, { fill: colors_1.turquoise, onClick: e => {
                        e.stopPropagation();
                        deleteText();
                    }, style: {
                        marginRight: media === 'Tablet' ? 16 : 0,
                    } }),
                editButton));
    }
};
const PopoverFormInput = ({ deleteText, id, isEditingText, label, media, startEditingText, text, updateText, fieldStyle, primaryTextSize = 'large', addButton, editButton, textMode, customPrimaryText, customSecondaryText, }) => {
    const containerFieldStyle = Object.assign({}, getFieldStyle(), fieldStyle);
    if (!text && !isEditingText) {
        return (React.createElement("div", { style: Object.assign({}, containerFieldStyle, { display: 'flex', justifyContent: 'space-between', alignItems: 'center' }), onClick: () => startEditingText() },
            customPrimaryText ? (customPrimaryText) : (React.createElement(Text_1.default, { text: label, label: true, size: primaryTextSize, textStyle: { color: colors_1.steel } })),
            addButton));
    }
    return (React.createElement("div", { style: Object.assign({}, containerFieldStyle, { display: 'flex', justifyContent: 'space-between', alignItems: 'center' }), onClick: (e) => {
            if (!isEditingText) {
                startEditingText();
            }
        } },
        React.createElement("div", { style: {
                flex: '1 1 0',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
            } },
            React.createElement(Text_1.default, { text: label, label: true, size: "small", textStyle: { display: 'block', color: colors_1.steel } }),
            customSecondaryText ? (customSecondaryText) : (React.createElement(Text_1.default, { text: text, id: id, contentEditable: isEditingText, handleChange: (str) => {
                    updateText(str);
                }, size: primaryTextSize, onBlurChange: isEditingText, textStyle: {
                    width: '100%',
                } }))),
        !isEditingText &&
            (textMode
                ? renderTextControlButtons(deleteText, media, startEditingText, text, editButton)
                : editButton)));
};
exports.default = PopoverFormInput;
